import { Grid2 } from '@mui/material'
import React from 'react'
// import styled from "styled-components";
import EmptyContent from './EmptyContent';

// const Empty = styled.p` 
//       font-size: 1.6rem;
//       font-weight: 500;
//       text-align: center;
//       margin: 2.4rem; 
//     `; 

const GridItems = ({ loading, data, slices, render, image, title, description }) => {
    if (!loading && !data?.length) return <EmptyContent image={image} title={title} description={description} />
    // if (!data?.length) return <Empty>No data to show at the moment</Empty>;  
    return (
        <>
            <Grid2 container justifyContent={'initial'} width={'100%'} spacing={1.5}>
                {slices ? data?.slice(0, slices)?.map(render) : data?.map(render)}
            </Grid2>
        </>
    )
}

export default GridItems